<template>
    <div>
      <b-button class="ml-1" variant="info" @click="startGame" v-if="!gamestarted">
          Spiel starten
      </b-button>
      <b-button class="ml-1" variant="danger" @click="endGame" v-if="gamestarted">
          Spiel beenden
      </b-button>
      <b-btn class="ml-1" v-b-modal="'saveGame'" v-if="gamestarted">Speichern</b-btn>
      <b-btn class="ml-1" v-b-modal="'loadGame'" v-if="!gamestarted">Laden</b-btn>
      <b-modal id="saveGame" @ok="saveGame">
        <b-form-input v-model="saveGameName"
            type="text"
            placeholder="Spielname"
        ></b-form-input>
        <b-form-checkbox class="ml-1" v-if="gamestarted" v-model="enableAutoSave" name="check-button" switch>
          Enable Autosave
        </b-form-checkbox>
      </b-modal>
      <b-modal id="loadGame" @ok="loadGame">
        <b-form-select v-model="loadGameIndex" :options="availableGames"></b-form-select>
      </b-modal>
       <FlashMessage position="right bottom"></FlashMessage>
    </div>
</template>

<script>

import LocalStorage from './../../localstorage'

const localStorage = new LocalStorage();

export default {
  name: 'Control',
   data () {
    return {
      loadGameIndex: 0,
      loadedGames: [],
      saveGameName: '',
      enableAutoSave: false,
    }
  },
  created: function() {
      this.loadedGames = localStorage.loadSavedGames();
      this.$store.dispatch('loadAutoSaveSettings')
      const settings = this.$store.getters.autoSaveSettings
      this.saveGameName = settings.name
      this.enableAutoSave = settings.enabled
  },
  computed: {
      gamestarted() {
          return this.$store.getters.gameStarted
      },
      players: function() {
          return this.$store.getters.players
      },
      availableGames: function() {
        if(!this.loadedGames) {
          return []
        }
        return this.loadedGames.map((game, index) => {return { value: index, text: game.gamename}})
      },
  }, 
  methods: {
    startGame() {
        if(this.players.length < 1) {
            alert('Du kannst wohl schlechte alleine spielen ;-)')
            return
        }
        this.$store.dispatch('startGame')
    },
    endGame() {
        this.$store.dispatch('endGame')
    },
    saveGame() {
        let saveGame = {'name': this.saveGameName, 'players': this.players, 'kartengeber': this.kartengeber}

        if(this.enableAutoSave) {
            this.$store.dispatch('enableAutoSave', this.saveGameName)
        }

        localStorage.saveGame(saveGame)
        this.flashMessage.show({
            status: 'success',
            title: 'Speichern erfolgreich!',
            message: "Das speichern der Partie war erfolgreich. Du kannst es nun jederzeit wieder laden :-)"
        });
    },
    loadGame() {
        const loadedGame = this.availableGames[0]
        this.$store.dispatch('loadGame', {gameName: loadedGame.text})
    },
  }
}
</script>